import { render, staticRenderFns } from "./GuidanceInline.vue?vue&type=template&id=a8e7b130&"
import script from "./GuidanceInline.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GuidanceInline.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports